module.exports = __webpack_public_path__ + "static/img/5.91ab65f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/5.png
// module id = tuPM
// module chunks = 0